import * as _ from 'lodash';
import { HTTP } from '@/http/http-client';

const registrationChild = ({ parentId, registrationForm, file }) => {
    const headers = {'Content-Type': 'multipart/form-data'};
    const formData = new FormData();
    _.keys(registrationForm.childForm).forEach(key => {
        registrationForm.childForm[key] && formData.append(`childForm.${key}`, registrationForm.childForm[key]);
    });

    registrationForm.contactPersonForms.forEach(function(obj, index) {
        _.keys(obj).forEach(key => {
            key === 'phone'
                ? formData.append(`contactPersonForms[${index}].${key}`, obj[key].split('  ').join(''))
                : formData.append(`contactPersonForms[${index}].${key}`, obj[key]);
        });
    });

    registrationForm.approvedPickupForms && registrationForm.approvedPickupForms.forEach(function(obj, index) {
        _.keys(obj).forEach(key => {
            obj[key] !== null && obj[key] !== '' && formData.append(`approvedPickupForms[${index}].${key}`, obj[key]);
        });
    });

    formData.append('image', file);

    return HTTP.post(`parents/${parentId}/children`, formData, { headers });
};

const getChildren = ( parentId ) =>
    HTTP.get(`parents/${parentId}/children`).then(({ data }) => data);

const getChildInfo = ({ parentId, childId }) =>
    HTTP.get(`parents/${parentId}/children/${childId}`).then(({ data }) => data);

const deleteChild = ({ parentId, childId }) =>
    HTTP.delete(`parents/${parentId}/children/${childId}`).then(({ data }) => data);

const getChildPhoto = ( childId ) =>
    HTTP.get(`children/${childId}/picture`).then(({ data }) => data);

const changeChildPhoto = ({ childId, file }) => {
    const headers = {'Content-Type': 'multipart/form-data'};
    const formData = new FormData();
    formData.append('image', file);
    return HTTP.patch(`children/${childId}/picture`, formData, { headers });
};

const removeChildPhoto = ( childId ) =>
    HTTP.delete(`children/${childId}/picture`).then(({ data }) => data);

const editChildInfo = ({ parentId, childId, childFullForm }) =>
    HTTP.put(`parents/${parentId}/children/${childId}`, childFullForm).then(({ data }) => data);

const getChildScheduleInfo = ({ parentId, childId }) =>
    HTTP.get(`/schools/slug/parents/${parentId}/children/${childId}/schedule`).then(({ data }) => data);

export default {
    registrationChild,
    getChildren,
    getChildInfo,
    getChildScheduleInfo,
    deleteChild,
    getChildPhoto,
    changeChildPhoto,
    removeChildPhoto,
    editChildInfo
};


// WEBPACK FOOTER //
// ./src/http/services/childrenService.js